// TimeIntervalSelect.jsx
import { useState, useEffect, useRef } from "react";
import "./TimeIntervalSelect.css";

const DEFAULT_OPTIONS = ["all", "12m", "30d", "7d", "24h"];

function TimeIntervalSelect({ value, onChange, options = DEFAULT_OPTIONS }) {
  const containerRef = useRef(null);
  const [highlightStyle, setHighlightStyle] = useState({});

  // 🔒 Only updates highlight style when `value` or `options` change
useEffect(() => {
  const idx = options.indexOf(value);
  if (containerRef.current && idx !== -1) {
    const btn = containerRef.current.querySelectorAll("button")[idx];
    if (btn) {
      setHighlightStyle({
        width: btn.offsetWidth + "px",
        transform: `translateX(${btn.offsetLeft}px)`,
      });
    }
  }
}, [value, options]);

  return (
    <div className="time-interval-select" ref={containerRef}>
      <div className="time-highlight" style={highlightStyle}></div>
      {options.map((opt) => (
        <button
          key={opt}
          type="button"
          className={`time-button time-option ${value === opt ? "active" : ""}`}
          onClick={() => onChange(opt)} // ✅ only trigger onClick, never in useEffect
        >
          {opt === "all" ? "All" : opt}
        </button>
      ))}
    </div>
  );
}

export default TimeIntervalSelect;
